module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ2_5.700193c5.svg";